<template>
    <div class="material-field-display-edit">
        <div v-if="readonly">
            {{ displayLabel || '-' }}
        </div>
        <div v-else>
            <div v-if="!isPrimaryRow" class="text-muted">
                {{ displayLabel || '-' }}
            </div>
            <div v-else-if="showSelector">
                <MaterialCategory
                    :value="value"
                    :config="{data: options}"
                    :read-only="false"
                    :append-to-body="true"
                    :multiple="false"
                    :open-on-focus="true"
                    :label="null"
                    @input="onInput"
                    @close="onSelectorClose"
                />
            </div>
            <button
                v-else
                type="button"
                class="field-link"
                @click="openSelector"
            >
                {{ displayLabel }}
            </button>
        </div>
    </div>
</template>

<script>
import { MaterialCategory } from '@/views/product/components/product-card/composition/components'

export default {
    name: 'MaterialFieldDisplayEdit',
    components: {
        MaterialCategory,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
        options: {
            type: Array,
            default() {
                return []
            },
        },
        displayLabel: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        isPrimaryRow: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showSelector: !this.value,
        }
    },
    watch: {
        value(next) {
            if (!next) {
                this.showSelector = true
            }
        },
    },
    methods: {
        openSelector() {
            this.showSelector = true
            this.$nextTick(() => {
                const root = this.$el
                if (!root) {
                    return
                }
                const input = root.querySelector('.vue-treeselect__input')
                if (input && typeof input.focus === 'function') {
                    input.focus()
                }
            })
        },
        onInput(value) {
            this.$emit('input', value)
            if (value) {
                this.showSelector = false
            }
        },
        onSelectorClose() {
            if (this.value) {
                this.showSelector = false
            }
        },
    },
}
</script>

<style scoped>
.field-link {
    background: transparent;
    border: 0;
    padding: 0;
    color: #2b6cb0;
    text-decoration: underline;
    cursor: pointer;
    text-align: left;
}
.field-link:hover {
    color: #1e4e8c;
}
</style>
